/**
 * Page header — Command Center style: title + subtitle on the left, actions on the right.
 */
export function NexaPageHeader({ title, subtitle, actions, testId }) {
  return (
    <div
      className="flex flex-col md:flex-row items-start md:items-center justify-between gap-2 mb-3"
      data-testid={testId}
    >
      <div>
        <h1 className="text-[15px] md:text-[16px] font-semibold tracking-[-0.02em] text-nexa-ink">{title}</h1>
        {subtitle && <p className="mt-0.5 text-[9.5px] #556579">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-1.5 flex-wrap">{actions}</div>}
    </div>
  );
}
